import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { BookShipmentConfirmResidentialResultType } from "../Types/BookShipmentConfirmResidentialResultType";

interface BookShipmentConfirmResidentialDialogProps extends DialogBaseProps {
  /** Fired with the customer's choice; exactly two outcomes, no dismiss. */
  onDone: (result: BookShipmentConfirmResidentialResultType) => void;
}

// Shown when the address lookup says this is likely a residential address but
// the customer didn't quote it as one. Two explicit outcomes only (like the
// legacy modal): add residential and requote, or proceed anyway. Replaces the
// legacy imperative modal.
export function BookShipmentConfirmResidentialDialog(
  props: BookShipmentConfirmResidentialDialogProps,
) {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="⚠️ Warning. Likely Residential Address."
      width="medium"
      hideCloseButton
      footer={
        <>
          <Button
            primary
            size="large"
            previousArrow
            onClick={() =>
              props.onDone(
                BookShipmentConfirmResidentialResultType.AddResidentialToQuote,
              )
            }
          >
            Add Residential and get new quotes
          </Button>
          <Button
            size="large"
            tone="danger"
            onClick={() =>
              props.onDone(BookShipmentConfirmResidentialResultType.Continue)
            }
          >
            I am confident this is not residential, continue!
          </Button>
        </>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        <Stack gap={2} align="start">
          <T size="base" color="secondary">
            We checked with our carrier partners and it is likely this will be
            billed as a residential address.
          </T>
          <T size="base" color="secondary">
            You did not select 'Residential Area' when quoting for this
            location. Additional charges may occur after delivery if you
            proceed, and our team determines that this was a residential area..
          </T>
        </Stack>
      </ControlPresentationProvider>
    </Dialog>
  );
}
